module.exports = __webpack_public_path__ + "static/media/Happy.fb17e82e.png";